import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ViewPdfButton.module.css";
import PDF from "./pdf_Icon.png";

/**
 * Interactive component, Button used to view a PDF.
 */
export function ViewPdfButton({ pdfName, showIcon = true, onClick }) {
  return (
    <div onClick={onClick} className={styles.container}>
    
      {showIcon && <img src={PDF} className={classNames(styles.image, styles.inline)} />}

      <div className={classNames(styles.inline, styles.text)}> {pdfName} </div>

    </div>
  );
}

ViewPdfButton.propTypes = {
  pdfName: PropTypes.string,
  onClick: PropTypes.func,
};
